import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";
import { toast } from "react-toastify";

import Image from "../../../elements/Image";
import { testimonialsDetails } from "../../../../services/testimonialsService";

export default function TestimonialDetails() {
  const { id } = useParams();

  const { data, isFetching } = useFetch({
    dependencies: ["testimonialDetails"],
    fetchFunction: async () => {
      try {
        const res = await testimonialsDetails(id);
        if (res?.success) {
          //   toast.success("Testimonial loaded successfully!");
          return res.data;
        } else {
          throw new Error("Failed to load testimonial");
        }
      } catch (err) {
        toast.error("Error fetching testimonial");
        return null;
      }
    },
  });

  if (isFetching || !data) {
    return (
      <div className="flex items-center justify-center h-[80vh] text-xl font-medium text-gray-500 animate-pulse">
        Loading testimonial...
      </div>
    );
  }

  const {
    name,
    rating,
    qualification,
    designation,
    company,
    comments,
    image,
    createdAt,
  } = data;

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-blue-100 flex flex-col items-center justify-start py-12 px-4">
      {/* Heading */}
      <h1 className="text-5xl font-extrabold text-gray-800 mb-12 text-center">
        What {name} says about{" "}
        <span className="text-yellow-300">Memory Doodle</span>
      </h1>

      {/* Card */}
      <div className="w-full max-w-4xl bg-gradient-to-tr from-green-300 to-teal-300 shadow-xl rounded-3xl p-10 text-black">
        {/* User Info */}
        <div className="flex flex-col md:flex-row items-center gap-8 mb-8">
          <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-white/50 shadow-lg">
            <Image
              src={image?.url}
              alt={name}
              width={128}
              height={128}
              classes="w-full h-full object-cover"
            />
          </div>
          <div className="text-center md:text-left">
            <h2 className="text-3xl font-bold">{name}</h2>
            <p className="text-black/90 text-sm mt-1">
              {designation} <span className="italic">{company}</span>
            </p>
            <p className="text-black/80 text-sm">{qualification}</p>
            <div className="mt-2 flex justify-center md:justify-start">
              <div className="text-yellow-400 text-xl">
                {"★".repeat(rating)}
                {"☆".repeat(5 - rating)}
              </div>
            </div>
          </div>
        </div>

        {/* Comment Content */}
        <div
          className="prose prose-invert prose-sm sm:prose-base max-w-none text-black"
          dangerouslySetInnerHTML={{ __html: comments }}
        />

        {/* Footer */}
        <div className="mt-10 text-right text-black/70 text-sm">
          Posted on {new Date(createdAt).toLocaleDateString()}
        </div>
      </div>
    </div>
  );
}
